class UnitConverter {
  constructor() {
    this.kelvinToCelsius = (x) => x - 273.15;
    this.celsiusToKelvin = (x) => x + 273.15;
    this.kelvinToFahrenheit = (x) => 1.8 * (x - 273.15) + 32;
    this.fahrenheitToKelvin = (x) => 5/9 * (x - 32) + 273.15;
    this.fahrenheitToCelsius = (x) => 5/9 * (x - 32);
    this.celsiusToFahrenheit = (x) => 1.8 * x + 32;
    this.metersPerSecondToKnots = (x) => x * 1.94384;
    this.knotToMetersPerSecond = (x) => x / 1.94384;
    this.metersPerSecondToKilometersPerHour = (x) => x * 3.6;
    this.metersPerSecondToMilesPerHour = (x) => x * 2.237;
    this.kilometersPerHourToMetersPerSecond = (x) => x / 3.6;
    this.kilometersPerHourToKnots = (x) => x * 0.539957;
    this.kilometersPerHourToMilesPerHour = (x) => x / 1.609;
    this.knotsToKilometersPerHour = (x) => x * 1.852;
    this.metersToNauticalMiles = (x) => x * 0.000539957;
    this.metersToStatuteMiles = (x) => x * 0.000621371;
    this.metersToFeet = (x) => x * 3.28084;
    this.metersToInches = (x) => x * 39.37;
    this.metersToMiles = (x) => x / 1609;
    this.milesPerHourToMetersPerSecond = (x) => x / 2.237;
    this.nauticalMilesToMeters = (x) => x * 1852;
    this.nauticalMilesToStatuteMiles = (x) => x * 1.15078;
    this.nauticalMilesToFeet = (x) => x * 6076;
    this.statuteMilesToMeters = (x) => x * 1609;
    this.statuteMilesToNauticalMiles = (x) => x * 0.868976;
    this.statuteMilesToFeet = (x) => x * 5280;
    this.feetToMeters = (x) => x * 0.3048;
    this.feetToNauticalMiles = (x) => x * 0.000164579;
    this.feetToStatuteMiles = (x) => x * 0.000189394;
    this.pascalsToKiloPascals = (x) => x / 1000;
    this.kiloPascalsToPascals = (x) => x * 1000;
    this.kilogramsPerMetersSquaredPerSecond = (x) => x * 3600 * 3;
    this.kilogramsPerMetersSquaredPerSecondToInchesPerHour = (x) => (x * 3600 * 3) / 25.4
    this.pascalsToHectoPascals = (x) => x * 1000;
    this.kiloPascalsToHectoPascals = (x) => x * 10;
    this.hectoPascalsToKiloPascals = (x) => x / 10;
    this.hectoPascalsToPascals = (x) => x * 100;
    this.millimeterPerHourToCentimeterPerHour = (x) => x / 10;
    this.centimeterPerHourToMillimeterPerHour = (x) => x * 10;
    this.proportionToPercentage = (x) => x * 100;
    this.percentageToProportion = (x) => x / 100;
    this.metersToKilometers = (x) => x / 1000;
    this.millimeterToCentimeter = (x) => x / 10;
    this.millimeterToInches = (x) => x / 25.4;
    this.millimeterPerHourToInchesPerHour = (x) => x / 25.4;
    this.centimeterToInches = (x) => x / 2.54;
    this.centimeterToMillimeter = (x) => x * 10;
    this.centiInchesToInches = (x) => x / 100;
    this.inchesToCentiInches = (x) => x * 100;
    this.inchesToMillimeters = (x) => x * 25.4;
    this.inchesToMeters = (x) => x / 39.37;
    this.inchesToCentimeters = (x) => x * 2.54;
    this.cubicMetersPerSecondToCubicFeetPerSecond = (x) => x * 35.315;
    this.converters = {
      '°C': {
        'F': this.celsiusToFahrenheit,
        'K': this.celsiusToKelvin
      },
      'C': {
        'F': this.celsiusToFahrenheit,
        'K': this.celsiusToKelvin
      },
      'F': {
        'C': this.fahrenheitToCelsius,
        'K': this.fahrenheitToKelvin
      },
      'K': {
        'C': this.kelvinToCelsius,
        '°C': this.kelvinToCelsius,
        'F': this.kelvinToFahrenheit
      },
      'M/S': {
        'kn': this.metersPerSecondToKnots,
        'km/h': this.metersPerSecondToKilometersPerHour,
        'mph': this.metersPerSecondToMilesPerHour
      },
      'm/s': {
        'kn': this.metersPerSecondToKnots,
        'km/h': this.metersPerSecondToKilometersPerHour,
        'mph': this.metersPerSecondToMilesPerHour
      },
      'mph': {
        'm/s': this.milesPerHourToMetersPerSecond
      },
      'kn': {
        'm/s': this.knotToMetersPerSecond,
        'km/h': this.knotsToKilometersPerHour
      },
      'km/h': {
        'kn': this.kilometersPerHourToKnots,
        'm/s': this.kilometersPerHourToMetersPerSecond,
        'mph': this.kilometersPerHourToMilesPerHour
      },
      'm': {
        'NM': this.metersToNauticalMiles,
        'SM': this.metersToStatuteMiles,
        'ft': this.metersToFeet,
        'km': this.metersToKilometers,
        'in': this.metersToInches,
        'miles': this.metersToMiles
      },
      'miles': {
        'm': this.statuteMilesToMeters
      },
      'NM': {
        'm': this.nauticalMilesToMeters,
        'SM': this.nauticalMilesToStatuteMiles,
        'ft': this.nauticalMilesToFeet,
        'miles': this.nauticalMilesToStatuteMiles
      },
      'SM': {
        'm': this.statuteMilesToMeters,
        'NM': this.statuteMilesToNauticalMiles,
        'ft': this.statuteMilesToFeet
      },
      'ft': {
        'm': this.feetToMeters,
        'NM': this.feetToNauticalMiles,
        'SM': this.feetToStatuteMiles
      },
      'Pa': {
        'kPa': this.pascalsToKiloPascals,
        'hPa': this.pascalsToHectoPascals
      },
      'kPa': {
        'Pa': this.kiloPascalsToPascals,
        'hPa': this.kiloPascalsToHectoPascals
      },
      'hPa': {
        'kPa': this.hectoPascalsToKiloPascals,
        'Pa': this.hectoPascalsToPascals
      },
      'kg/m^2/s': {
        'mm/hr': this.kilogramsPerMetersSquaredPerSecond,
        'mm/h': this.kilogramsPerMetersSquaredPerSecond,
        'in/hr': this.kilogramsPerMetersSquaredPerSecondToInchesPerHour
      },
      'kg/m^2/hr': {
        'in/hr': this.millimeterPerHourToInchesPerHour
      },
      'mm/h': {
        'cm/h': this.millimeterPerHourToCentimeterPerHour
      },
      'cm/h': {
        'mm/h': this.centimeterPerHourToMillimeterPerHour
      },
      'mm': {
        'cm': this.millimeterToCentimeter,
        'in': this.millimeterToInches
      },
      'cm': {
        'mm': this.centimeterToMillimeter,
        'in': this.centimeterToInches
      },
      'Proportion': {
        '%': this.proportionToPercentage
      },
      '1': {
        '%': this.proportionToPercentage
      },
      '%': {
        'Proportion': this.percentageToProportion
      },
      'centi-inches': {
        'in': this.centiInchesToInches
      },
      'in': {
        'centi-inches': this.inchesToCentiInches,
        'mm': this.inchesToMillimeters,
        'm': this.inchesToMeters,
        'cm': this.inchesToCentimeters
      },
      'm^3/s': {
        'ft^3/s': this.cubicMetersPerSecondToCubicFeetPerSecond
      },
      'mm/hr': {
        'in/hr': this.millimeterPerHourToInchesPerHour,
        'cm/hr': this.millimeterPerHourToCentimeterPerHour
      }
    }
  }

  convert(value, sourceUnit, targetUnit, precision = 1) {
    const sourceUnitConverters = this.converters[sourceUnit];
    if (sourceUnitConverters) {
      const converterFunction = sourceUnitConverters[targetUnit];
      if (converterFunction) {
        return parseFloat(converterFunction(value).toFixed(precision));
      }
    }

    if (!isNaN(value)) {
      return parseFloat(value.toFixed(precision));
    }

    return value;
  }
}

module.exports = {
  UnitConverter
};